import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const CopyIcon = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path id="CopyIcon" d="M68.8,0H42.614A4.376,4.376,0,0,0,38.25,4.364V34.909h4.364V4.364H68.8Zm6.545,8.727h-24a4.376,4.376,0,0,0-4.364,4.364V43.636A4.376,4.376,0,0,0,51.341,48h24A4.376,4.376,0,0,0,79.7,43.636V13.091A4.376,4.376,0,0,0,75.341,8.727Zm0,34.909h-24V13.091h24Z" transform="translate(-38.25)" fill={fill} />
    </svg>
  );
};

CopyIcon.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

CopyIcon.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};